import React, { Fragment } from 'react';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import classNames from 'classnames';
import IconRow from '../../icon-row';
import GetDirections from './get-directions';
import StoreLink from './store-link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const showDirections = (latitude, longitude) => latitude !== null && longitude !== null;
const numberOfStores = stores => {
  if (Array.isArray(stores)) {
    return stores.length;
  } else {
    return 0;
  }
};
const ParkingZone = props => {
  const bestParkingFor = (props.bestParkingFor || []).filter(store => store);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(props.className, style.parkingZone),
    "data-id": "parking-zone_index_ParkingZone_div",
    children: [/*#__PURE__*/_jsx(Heading, {
      type: "small",
      "data-id": "parking-zone_index_ParkingZone_div_Heading",
      children: props.carParkName
    }), /*#__PURE__*/_jsxs("div", {
      className: style.location,
      "data-id": "parking-zone_index_ParkingZone_div_div",
      children: [/*#__PURE__*/_jsx(IconRow, {
        className: style.locationPin,
        text: props.carParkLocation,
        icon: "location-drop-pin",
        "data-id": "parking-zone_index_ParkingZone_div_IconRow"
      }), /*#__PURE__*/_jsx("div", {
        className: style.availabilityDirections,
        "data-id": "parking-zone_index_ParkingZone_div_div",
        children: showDirections(props.latitude, props.longitude) && /*#__PURE__*/_jsx(GetDirections, {
          className: style.getDirections,
          latitude: props.latitude,
          longitude: props.longitude,
          "data-id": "parking-zone_index_ParkingZone_GetDirections"
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: style.lower,
      "data-id": "parking-zone_index_ParkingZone_div_div",
      children: [/*#__PURE__*/_jsxs(Paragraph, {
        "data-id": "parking-zone_index_ParkingZone_div_Paragraph",
        children: ["Entrance on ", props.carParkEntrance]
      }), /*#__PURE__*/_jsxs(Paragraph, {
        className: style.nearestStores,
        "data-id": "parking-zone_index_ParkingZone_div_Paragraph_8",
        children: [bestParkingFor && bestParkingFor.length > 0 && 'Nearest stores ', (bestParkingFor || []).map((store, counter, stores) => /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(StoreLink, {
            store: store,
            centreSlug: props.centreSlug,
            "data-id": "parking-zone_index_ParkingZone_Fragment_StoreLink"
          }, "".concat(props.centreSlug, "-").concat(store.sys.id)), counter < numberOfStores(stores) - 1 && ', ']
        }, store.sys.id))]
      })]
    })]
  });
};
export default ParkingZone;